/** Entry edit (rename, share, cover) için mevcut share listesini email dizisine çevirir. */
export function extractShareEmailsFromEntry(
  share: unknown[] | undefined | null
): string[] {
  if (!Array.isArray(share)) return [];
  return share
    .map((s) => (typeof s === 'string' ? s : (s as { email?: string })?.email))
    .filter((email): email is string => typeof email === 'string' && email.trim().length > 0);
}

export type EntryEditPayload = {
  id: number;
  name: string;
  share: string[];
  thumbnail?: Blob;
};

/** Rename vb. işlemlerde backend'in gönderilmeyen alanları silmemesi için mevcut değerleri korur. */
export function buildEntryEditPayload(
  item: { id: number; name: string; share?: unknown[] | null },
  overrides: { name?: string; thumbnail?: Blob }
): EntryEditPayload {
  return {
    id: item.id,
    name: overrides.name ?? item.name,
    share: extractShareEmailsFromEntry(item.share),
    ...(overrides.thumbnail !== undefined ? { thumbnail: overrides.thumbnail } : {}),
  };
}
